<template>
  <div>
    <div>
      <GoogleMap></GoogleMap>
    </div>
    <div class="container">
    <h1>Verfügbare Lieferaufträge</h1>
    <b-progress v-if="loading"></b-progress>
    <span v-if="orders.length ===0">Keine Aufträge verfügbar</span>
    <b-table-simple>
      <b-thead>
        <b-th>Abholungort</b-th>
        <b-th>Lieferort</b-th>
        <b-th>Produkt</b-th>
        <b-th>Gebühr</b-th>
        <b-th>Aktion</b-th>
      </b-thead>
    </b-table-simple>
    <div v-for="order in orders" :key="order.id">
      <p style="font-weight: bold; margin-bottom: 0; margin-left: 0.75rem;">
        Lieferung {{ order.name }}
      </p>
      <div v-for="vendor in order.vendors" :key="vendor.name">
        <b-table-simple>
          <b-tbody>
            <b-tr v-for="(item, index) in vendor.productItems" :key="item.id">
              <b-td :rowspan="vendor.productItems.length" v-if="index === 0">{{ item.vendorAddress }}</b-td>
              <b-td :rowspan="vendor.productItems.length" v-if="index === 0">{{ item.destinationString }}</b-td>
              <b-td><small>{{ item.quantity }}x {{ item.name }}</small></b-td>
              <b-td :rowspan="vendor.productItems.length" v-if="index === 0">{{ vendor.deliveryPrice }}</b-td>
              <b-td :rowspan="vendor.productItems.length" v-if="index === 0">
                <RouteButton :item="item"></RouteButton>
                <ClaimButton :vendor="vendor"></ClaimButton>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
      <small>* Sie sind bereits der Verkäufer dieses Produkts.</small>
    </div>
    <b-button @click="previousPage" v-if="hasPreviousPage && !loading">Previous</b-button>
    <b-button @click="nextPage" v-if="pageInfo.hasNextPage && !loading">Next</b-button>

  </div>
</template>

<script>
import orders from "@/api/orders";
import GoogleMap from "@/pages/JobsPage/GoogleMap";
import ClaimButton from "@/pages/JobsPage/ClaimButton";
import RouteButton from "@/pages/JobsPage/RouteButton";
import {Item, Order, Vendor} from "@/utils/model";
import uberConfig from "@/api/uberConfig";


export default {
  components: { GoogleMap, ClaimButton, RouteButton },
  data () {
    return {
      orders: [],
      loading: false,
      currentPage: 0,
      perPage: 10,
      totalRows: 0,
      cursors:[null],
      pageInfo: {
        hasNextPage: true
      },
      processingWindow: {}
    }
  },
  computed: {
    hasPreviousPage () {
      return this.cursors[this.currentPage - 1] !== undefined
    }
  },
  async created() {
    this.processingWindow = await uberConfig.get()
    this.processingWindow.current.start = Date.parse(this.processingWindow.current.start)
    this.processingWindow.previous.start = Date.parse(this.processingWindow.previous.start)
    this.processingWindow.previous.end = Date.parse(this.processingWindow.previous.end)
    this.cursors[1] = await this.loadPage(0)
  },
  methods: {
    async loadPage(pageNumber) {
      this.loading = true
      const data = await orders.get(this.cursors[pageNumber], this.perPage)
      for (const order of data.orders) {
            const itemsData = await orders.getOrderItems(order.node.id)
            const itemsByVendor = itemsData.reduce(
                (byVendor, item) => {
                  byVendor[item.node.vendor] = byVendor[item.node.vendor] || []
                  byVendor[item.node.vendor].push(new Item(item, order.node))
                  return byVendor
                },
                {}
            )
            let vendors = []
            const orderObject = new Order(order.node, itemsData)
            for ( const vendor in itemsByVendor ){
              vendors.push(new Vendor(vendor, itemsByVendor[vendor], orderObject))
            }
            orderObject.vendors = vendors
            this.orders.push(orderObject)
      }
      this.pageInfo = data.pageInfo
      this.loading = false
      return data.orders[data.orders.length - 1].cursor
    },
    nextPage() {
      this.loadPage(this.currentPage + 1).then((cursor) => {
        this.currentPage += 1
        this.cursors[this.currentPage + 1] = cursor
      })
    },
    previousPage() {
      this.loadPage(this.currentPage - 1).then(() => this.currentPage -= 1)
    },
  }
}
</script>
